export const ERROR_NOT_PRESENT = null;

export const STATE_ROOT_KEY = 'registration';

export const STATUS = {
  PROMPT: 'PROMPT',
  LOADING: 'LOADING',
  COMPLETE: 'COMPLETE',
  VERIFYING_EMAIL: 'VERIFYING_EMAIL',
  VALID_TOKEN: 'VALID_TOKEN',
  INVALID_TOKEN: 'INVALID_TOKEN',
  EXPIRED_TOKEN: 'EXPIRED_TOKEN',
};

export const INITIAL_STATE = {
  status: STATUS.PROMPT,
  error: ERROR_NOT_PRESENT,
};
